import type { CampaignSummary } from '../../api/client.ts';

export const DELIVERY_LABELS: Record<CampaignSummary['deliveryType'], string> = { scheduled: 'Scheduled', action_based: 'Action-based', api_triggered: 'API-triggered' };
export const CHANNEL_LABELS: Record<CampaignSummary['channels'][number], string> = { push: 'Push', email: 'Email', sms: 'SMS', content_card: 'Content Card', in_app: 'In-app message', webhook: 'Webhook' };
